import React, { Component } from 'react';
import { revenueStyles as styles } from './LandingSubComponentStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import Fade from 'react-reveal/Fade';
import { CircularProgress } from '@material-ui/core';
import { getAmount } from '../../../utils/functionUtils';
import HelpOutline from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { revenueView, validation ,oyoFormView} from '../../../Enums';
import { logEvent } from '../../../services/Analytics';
import { path } from '../../../utils/index'
import { FlexColumn } from '../../../partnerStyles';
import { guc } from '../../../services/Localisation';

class Revenue extends Component {
  state = {
    showToolTip: false,
    viewMode: revenueView.clickToSee
  };

  setViewMode = () => {
    let view = revenueView.clickToSee;
    if (this.props.globalData.earning_potential_data.isFetching) {
      view = revenueView.loading;
    } else if (this.props.globalData.earning_potential_data.data.length > 0) {
      let obj = this.props.globalData.earning_potential_data.data[0];
      if (obj.arr && obj.occupancy && obj.currency) {
        view = revenueView.yesData;
        this.setAmount(this.props.globalData.number_of_rooms);
      } else {
        view = revenueView.noData;
      }
    } else if (this.props.globalData.earning_potential_data.noDataForCity) {
      view = revenueView.noData;
    }
    this.setState({ viewMode: view });
  };

  handleGetRevenue = () => {
    if (
      this.props.validateOneField(validation.LOCATION_OBJECT) &&
      this.props.validateOneField(validation.REVENUE_POTENTIAL)
    ) {
      this.setViewMode();
    }
  };

  setAmount = (numberOfRooms) => {
    if (path(this.props.globalData, 'earning_potential_data.data.length', 0) === 0) return;
    let obj = this.props.globalData.earning_potential_data.data[0];
    let amt = getAmount(
      obj.arr,
      obj.occupancy,
      numberOfRooms,
      obj.currency,
      this.props.globalData.locale === 'in'
    );
    this.props.globalActions.updateEstimatedRevenue(amt);
    const roomCountRevenueData = {
      roomCount: numberOfRooms,
      estimatedRevenue: amt
    };
    logEvent(this.props.eventCategory, this.props.eventAction, JSON.stringify(roomCountRevenueData));
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.globalData.earning_potential_data != prevProps.globalData.earning_potential_data) {
      this.setViewMode();
    }
  }

  componentDidMount() {
    this.setViewMode();
    if (
      this.props.globalData.earning_potential_data.data &&
      this.props.globalData.earning_potential_data.data.length > 0
    ) {
      this.setAmount(this.props.globalData.number_of_rooms);
    }
  }

  setNumberOfRooms = value => {
    let newNumberofRooms = parseInt(value, 10);
    if (isNaN(newNumberofRooms) || newNumberofRooms > 9999) {
      newNumberofRooms = this.props.globalData.number_of_rooms;
    }
    if (value == '') newNumberofRooms = 0;
    this.props.globalActions.updateNumberOfRooms(newNumberofRooms);
    this.setAmount(newNumberofRooms);
  };
  getImage = image_id => {
    if (image_id in LandingImages) {
      return (
        S3HOST +
        '/' +
        this.props.globalData.universal_translations[
          LandingImages[image_id][this.props.viewMode]
        ]
      );
    }
    console.log(image_id + ' image not initialized.');
    return null;
  };

  getStyle = styleId => {
    if (styleId in styles) {
      return styles[styleId][this.props.viewMode];
    }
  };

  getUniversalContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.universal_translations &&
      this.props.viewMode
    ) {
      if (key in this.props.globalData.universal_translations)
        return this.props.globalData.universal_translations[key];
    }
    return null;
  };
  
  renderLifeText = () => {
    return <span style={FlexColumn}>
              {guc('Occupancy')}
      <span>{'('}{guc('no_of_beds')}{')'}</span>
    </span>;
  };
  
  render() {
    let gi = this.getImage;
    let gs = this.getStyle;
    let guc = this.getUniversalContent;

    return (
      <div style={gs('revenueMainContainer')} className={'animate'}>
        <Fade>
          <div style={gs('bedroomsAndIconANDRoomContainer')}>
            <div style={gs('bedroomAndIconContainer')}>
              <img src={gi('icon_bedroom')} />
              
              <span style={gs('bedroomText')}>
                {this.props.formMode === oyoFormView.lifeBasic ? this.renderLifeText() : guc('number_of_rooms')}
              </span>
            </div>

            <div style={gs('arrowsAndRoomsContainer')}>
              <i
                style={gs('leftArrow')}
                onClick={() => {
                  this.setNumberOfRooms(
                    this.props.globalData.number_of_rooms - 1 >= 0
                      ? this.props.globalData.number_of_rooms - 1
                      : 0
                  );
                }}
              />

              <input
                type="text"
                name="hello"
                value={this.props.globalData.number_of_rooms}
                style={{ ...gs('numberOfRooms') }}
                onChange={e => this.setNumberOfRooms(e.target.value)}
              />
              <i
                style={gs('rightArrow')}
                onClick={() => {
                  this.setNumberOfRooms(
                    this.props.globalData.number_of_rooms + 1
                  );
                }}
              />
            </div>
          </div>
          
          <div style={gs('amountContainer')}>
            {this.state.viewMode === revenueView.yesData && this.props.globalData.estimated_revenue &&
            this.props.formMode !== oyoFormView.lifeBasic &&
            (
              <div
                style={{
                  width: '100%',
                  position: 'relative',
                  textAlign: 'center'
                }}
              >
                <strong style={gs('rev_earned')}>{guc('earn_up_to')}</strong>
                <strong style={gs('amount')}>{this.props.globalData.estimated_revenue}</strong>
                <strong style={gs('perYear')}>{guc('per_year')}</strong>

                <ClickAwayListener
                  onClickAway={() => this.setState({ showToolTip: false })}
                >
                  <Tooltip
                    open={this.state.showToolTip}
                    onClick={() => this.setState({ showToolTip: true })}
                    className={'hover pointerEvents'}
                    title={<div style={{pointerEvents:'all'}}>{guc('earning_disclaimer')}</div>}
                  >
                    <HelpOutline style={gs('help_revenue')} />
                  </Tooltip>
                </ClickAwayListener>
              </div>
            )}

            {(this.state.viewMode === revenueView.loading
            && this.props.formMode !== oyoFormView.lifeBasic) && (
              <div>
                <CircularProgress />
              </div>
            )}
  
            {(this.state.viewMode === revenueView.clickToSee &&
                this.props.formMode !== oyoFormView.lifeBasic) && (
              <div
                style={gs('clickToSee')}
                className={'hover'}
                onClick={this.handleGetRevenue}
              >
                <div style={gs('centerTextRev')}>{guc('click_to_see_rev')}</div>
              </div>
            )}

            {this.state.viewMode === revenueView.noData &&
             this.props.formMode !== oyoFormView.lifeBasic&&(
              <div style={gs('clickToSee')}>
                <div style={gs('centerTextRev')}>{guc('no_data_rev')}</div>
              </div>
            )}
          </div>
          {/*)}*/}
        </Fade>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

Revenue.defaultProps = {
  loader:false
}

export default connect(mapStateToProps, mapDispatchToProps)(Revenue);
